import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventPlaceName = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['placeName'] => getEvent(eventKey)(store).placeName;
